import { AppView, VideoView, VideoControlBarView, LivescoreWidget, LivesettlementsWidget, LivetableWidget, StatisticsRankingWidget,
         StatisticsTeamformWidget, StatisticsHead2headWidget, View, TextView } from "@gaming/srvg-classes-core";
import { OverlayView } from "../OverlayContainerView/OverlayView";
import { MatchdayArea } from "../MatchdayArea";
import { WIDGET_LIVETABLE, WIDGET_STATISTICS_TEAMFORM, WIDGET_STATISTICS_RANKING,
    WIDGET_LIVESETTLEMENTS, WIDGET_LIVESCORE, WIDGET_STATISTICS_HEAD2HEAD } from "@gaming/srvg-classes-core";

/**
 * Main view class for the VBL retail version.
 */
export class RetailView extends AppView {
    matchdayTextView: TextView;
    seasonTextView: TextView;
    overlayContainerView: OverlayView;
    videoView: VideoView;
    videoControlBar: VideoControlBarView;
    widgetLivescore: LivescoreWidget;
    widgetLivesettlements: LivesettlementsWidget;
    widgetLivetable: LivetableWidget;
    widgetStatisticsRanking: StatisticsRankingWidget;
    widgetStatisticsTeamform: StatisticsTeamformWidget;
    widgetStatisticsTeamformExtendedBetting: StatisticsTeamformWidget;
    widgetStatisticsHead2headExtendedBetting: StatisticsHead2headWidget;
    matchdayAreas: MatchdayArea[];
    numberOfMatchdayAreas: number;
    videoControlBarTimeout: any;

    constructor(options){
        options = options || {};
        options.selector = options.selector || '#vbl_container';
        super(options);

        /******************* initialize views ************************/

        this.matchdayTextView = this.addSubView( new TextView( { selector: '#text_view_matchday' } ) );
        this.seasonTextView = this.addSubView( new TextView( { selector: '#text_view_season' } ) );

        var hdChannel = null;
        if( srvg.videooptions.alt_videobasename ) {
            if( !srvg.featuresInstances.getStartWithHd() ) {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.videobasename;
            }
            else {
                hdChannel = srvg.videooptions.serverurl+srvg.videooptions.alt_videobasename;
            }
        }

        // Setting the videoHandlers order for the videoView
        var videoHandlers = [];
        if (srvg.Player.getWorkingStreamType() == 'flash') {
            videoHandlers = ['flash', 'hls', 'html5'];
        } else {
            if(srvg.featuresInstances.getFlashVideoByDefault() === false)
                videoHandlers = ['hls', 'flash', 'html5'];
        }

        this.videoView = this.addSubView( new VideoView( {
            channel: srvg.videooptions.defaultchannel || 0,
            playerOptions: {
                hdChannel: hdChannel,
                //soundswitch: 'soundswitch', videoswitch: 'switch', // TODO are these needed?
                hdswitch: srvg.videooptions.alt_videobasename ? '#hdswitch' : null,
                overlays: '#overlay_container',
                useLiveplayer: true,
                hidePlayButton: false,
                hideStopButton: true,
                hide:'display',
                muted: srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute,
                //vod: srvg.videooptions.flostVideosets ? true : false,
                vod: false,
                loglevel: 0,
                ui: {
                    enabled: true,
                    videoControls : false,
                    fullscreen : false,
                    controlBarHideDelay: 3
                },
                poster: srvg.url.image+'video/poster.png',
                noButton: false,
                autoplay: true,
                swf: srvg.url.webroot+'liveplayer/srplayer.swf',
                videoHandlers: videoHandlers,
                smoothTransition: false,
                gui: false,
                micro: false,

            }
        }, srvg ) );



        this.videoControlBar = this.addSubView( new VideoControlBarView( { selector: '#videocontrolbar' } ) );

        this.videoControlBar.playpauseButton.$domNode.addClass( 'enabled' );
        if( srvg.videooptions.alt_videobasename ) {
            this.videoControlBar.hdButton.$domNode.addClass( 'enabled' );
            if (!srvg.featuresInstances.getStartWithHd()) {
                this.videoControlBar.hdButton.$domNode.addClass( 'pressed' );
            }
        }
        this.videoControlBar.soundButton.$domNode.addClass( 'enabled' );
        if( srvg.featuresInstances.getDisableAudioByDefault() || srvg.videooptions.startMute || parseInt(localStorage.getItem('livePlayerVolume'), 10) == 0  ) {
            this.videoControlBar.soundButton.$domNode.addClass( 'pressed' );
        }

        this.widgetLivetable = null;
        this.widgetStatisticsTeamform = null;
        this.widgetStatisticsRanking = null;
        this.widgetLivesettlements = null;
        this.widgetLivescore = null;

        if (srvg.widgets.enabled && (window as any).vswidgets.init ) {
            srvg.widgetLoader = (window as any).vswidgets.init({});
            var widgetList = [],
                widgetGroup = 'VBL',
                platformOption = 'retail-large',
                platformOptionOverlays = 'overlay-large';


            if( srvg.widgets[WIDGET_LIVETABLE].enabled ) {
                this.widgetLivetable = this.addSubView( new LivetableWidget({
                    games:false,
                    wins:false,
                    losses:false,
                    score:false,
                    showHeader: false,
                    widgetGroup: widgetGroup,
                    platform: platformOption
                }) );
                widgetList.push( this.widgetLivetable );
            }
            if( srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled ) {
                this.widgetStatisticsTeamform = this.addSubView( new StatisticsTeamformWidget({
                    widgetGroup: widgetGroup,
                    platform: platformOptionOverlays
                }) );
                widgetList.push( this.widgetStatisticsTeamform );
            }
            if( srvg.widgets[WIDGET_STATISTICS_RANKING].enabled ) {
                this.widgetStatisticsRanking = this.addSubView( new StatisticsRankingWidget({
                    widgetGroup: widgetGroup,
                    platform: platformOptionOverlays
                }) );
                widgetList.push( this.widgetStatisticsRanking );
            }
            if( srvg.widgets[WIDGET_LIVESETTLEMENTS].enabled  &&  !srvg.featuresInstances.getDisableOdds()) {
                this.widgetLivesettlements = this.addSubView( new LivesettlementsWidget({
                    widgetGroup: widgetGroup,
                    platform: platformOptionOverlays
                }) );
                widgetList.push( this.widgetLivesettlements );
            }
            if( srvg.widgets[WIDGET_LIVESCORE].enabled ) {
                this.widgetLivescore = this.addSubView( new LivescoreWidget({
                    widgetGroup: widgetGroup,
                    numOfColumns: 1,
                    playButtonPosition: 'last',
                    showTablePosition: true,
                    singlePlayButton: true,
                    showRaceToX: false,
                    platform: platformOption
                }) );
                widgetList.push( this.widgetLivescore );
            }

            if (srvg.config.extendedBetting){
                if(srvg.widgets[WIDGET_STATISTICS_TEAMFORM].enabled){
                    this.widgetStatisticsTeamformExtendedBetting = this.addSubView( new StatisticsTeamformWidget({
                        widgetGroup: widgetGroup, element: '#statistics_extendedbetting_teamform',
                        platform: platformOption
                    }) );
                    widgetList.push( this.widgetStatisticsTeamformExtendedBetting );
                }
                if (srvg.widgets[WIDGET_STATISTICS_HEAD2HEAD].enabled){
                    this.widgetStatisticsHead2headExtendedBetting = this.addSubView( new StatisticsHead2headWidget({
                        widgetGroup: widgetGroup, element: '#statistics_extendedbetting_head2head',
                        platform: platformOption
                    }) );
                    widgetList.push( this.widgetStatisticsHead2headExtendedBetting );
                }
            }


            srvg.eventExchange.addEventHandler(widgetList, 'all', 'addWidget', 'handleAddWidgetEvent');
            srvg.eventExchange.addEventHandler(widgetList, 'all', 'destroyWidget', 'handleDestroyWidgetEvent');
        }

        this.overlayContainerView = this.addSubView( new OverlayView( { selector: '#overlay_container' } ) );
        this.overlayContainerView.push( new View( { selector: '#overlay_layer_pre_match_1' } ), 'pre_match_1' );
        this.overlayContainerView.push( new View( { selector: '#overlay_layer_pre_match_2' } ), 'pre_match_2' );
        this.overlayContainerView.push(
            new View({selector: '#overlay_layer_pre_match_extended_betting'}), 'pre_match_extendedBetting'
        );



        //show only the live settlement overlay, if the odds are disabled
        if(!srvg.featuresInstances.getDisableOdds()){
            this.overlayContainerView.push( new View( { selector: '#overlay_layer_post_match'  } ), 'post_match' );
        }
        //this.overlayContainerView.push( new SrvgView( { selector: '#overlay_layer_post_season' } ), 'post_season' );

        this.numberOfMatchdayAreas = options.numberOfMatchdayAreas ||2;

        this.matchdayAreas = [];
        for( var i = 0; i < this.numberOfMatchdayAreas; i++ ) {
            this.matchdayAreas.push( this.addSubView( new MatchdayArea({
                selector: '#matchdayarea_'+i, offset: i,
                hasOddsFrame: true,
                hasOddsGallery:true,
                oddsGallery: {
                    numberOfItemsToShow: 1,
                    displayTime: 14
                }
            }) ) );
        }

        var that = this;

        this.videoControlBarTimeout = window.setTimeout( function() { that.videoControlBar.hide(); }, srvg.config.videoControlBar.showTime );

        $('#video_container').mousemove( function() {
            if( ! that.videoControlBar.isShown ) {
                that.videoControlBar.show();
            }
            if( that.videoControlBarTimeout ) {
                window.clearTimeout( that.videoControlBarTimeout );
            }
            that.videoControlBarTimeout = window.setTimeout( function() { that.videoControlBar.hide(); that.videoControlBarTimeout = null; }, srvg.config.videoControlBar.showTime );
        } );
    }
}